import React from 'react';
import { ReactComponent as IconClose } from "../../images/svg/close.svg";

const ParticipantHeader = ({ onClose, totalParticipants }) => (
  <div className="participants-header">
    <div className="participants-header-content">People ({totalParticipants})</div>
    <span className="participants-header-close" onClick={onClose}>
      <IconClose />
    </span>
  </div>
);

export default ParticipantHeader;